import { useGetOrganizationById } from "@/features/organization/hooks/useQuery/useGetOrganizationById";
import { setOrganizationContext } from "@/lib/utils/sentry/context/setOrganizationContext";
import { useOrganizationStore } from "@/lib/zustand/useStore";
import { useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
export default function OrganizationProvider() {
    const { orgId } = useParams()
    const { setOrganization, organization: storeOrganization } = useOrganizationStore();
    const {data: organization } = useGetOrganizationById(Number(orgId!))
    useEffect(() => {
        sessionStorage.setItem('orgId', orgId!)
        if(organization){
            setOrganization(organization)
        }
    },[orgId, organization, setOrganization])
    useEffect(() => {
        setOrganizationContext(storeOrganization);
    }, [storeOrganization]);
    return (
        <>
            <Outlet />
        </>
    )
}